/**
 * useRegions — tiny hook that fetches the list of active regions once.
 *
 * Used by every create / edit form and filter dropdown that offers a region
 * picker. Kept simple deliberately: no cache invalidation logic — the
 * Masters → Regions admin page reloads its own list and other pages will
 * refetch on their next mount.
 */
import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function useRegions({ includeArchived = false } = {}) {
  const [regions, setRegions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await api.get(`/regions${includeArchived ? "?include_archived=true" : ""}`);
        if (alive) setRegions(res.data || []);
      } catch (_e) {
        if (alive) setRegions([]);
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, [includeArchived]);

  return { regions, loading };
}
